module.exports = __webpack_public_path__ + "img/6.e26773d8.png";